function i4_Image(element) {
  this.$element = $(element);

  this.selectors = {
    container: '.js-image-container'
  };

  this.data = {
    pictureSrc: 'picture-src',
    altText: 'alt-text',
    legendText: 'legend',
    viewContainer: 'view-container',
    galleryId: 'gallery-id'
  };

  this.init = function () {
    this.galleryId = this.$element.data(this.data.galleryId);
    this.viewContainer = this.$element.data(this.data.viewContainer);
    this.pictureSrc = this.$element.data(this.data.pictureSrc);
    this.altText = this.$element.data(this.data.altText);
    this.legendText = this.$element.data(this.data.legendText);

    this.$container = this.$element.find(this.selectors.container);
    this.i4Gallery = i4_Gallery.get(this.galleryId).
    set_option({
      view_container: this.viewContainer
    });

    this.imageId = this.i4Gallery.
    add_image({
      src: this.pictureSrc,
      altText: this.altText,
      legendText: this.legendText
    });

    this.$container.on('click', this.$onClickImage.bind(this));
    this.$container.css('cursor', 'pointer');
  };

  this.$onClickImage = function (event) {
    event.preventDefault();

    this.i4Gallery.show(this.imageId);
  };
}
